import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsDestinationsBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsDestinationsBlockEntity
